var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 14683"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14662"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.884 8.093h18.233",
  "data-name": "Line 1224"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.698 15.907h13.395",
  "data-name": "Line 1225"
})))));
export { SvgMenuList as ReactComponent };
export default __webpack_public_path__ + "static/media/menu_list.4ca1c21db392963ebcfa308628444821.svg";